export const styles = {
  sectionBackground: {
    textAlign: "center",
    paddingTop: { xs: "56px", sm: "120px" },
    paddingBottom: { xs: "56px", sm: "120px" },
  },
  articlesRow: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "flex-start",
    gap: 2.5,
    "@media (max-width: 1100px)": {
      flexDirection: "column",
      gap: 10,
    },
  },
};
